import React, { Component, } from 'react'
import PropTypes from 'prop-types'

import Modal from 'components/_molecules/Modal'

import EventSummary from 'components/EventSummary'

import './styles.css'

class EventSummaryModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    eventSummary: PropTypes.shape({
      event: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }),
    }),
  }
  static defaultProps = {
    modalTitle: '',
    eventSummary: undefined,
  }
  render() {
    const { isOpen, onRequestClose, eventSummary, } = this.props
    if (!eventSummary) {
      return null
    }
    return (
      <Modal
        isOpen={isOpen}
        modalHeader={false}
        modalTitle={eventSummary.event.name}
        onRequestClose={onRequestClose}
        shouldCloseOnOverlayClick={false}
        className="event-summary-modal"
        overlayClassName="event-summary-modal-overlay"
      >
        <EventSummary {...eventSummary} />
      </Modal>
    )
  }
}

export default EventSummaryModal



// WEBPACK FOOTER //
// ./src/components/EventSummaryModal/index.js